import emptyState from "./emptyState";
import { actionTypes } from "./action";
import { immutableSet } from "../../../utils/immutable";

interface IAction {
  type: any;
  payload: any;
}

const ACTION_HANDLERS = {
  [actionTypes.SET_ERROR]: (state: any, action: IAction) =>
    immutableSet(["error"], action.payload, state),
};

// Reducer
export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
